import logo from '../images/icon.png';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import '../style/parallax-star.css';
import { IoKeyOutline, IoMail } from "react-icons/io5";

import { RequestPasswordReset } from '../api/Authentication';
import Modal from '../components/Modal';
import { useLanguage } from '../i18n/LanguageContext';

export default function ForgotPassword() {
  const { t } = useLanguage();
  let history = useHistory();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [iShow, setiShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  useEffect(() => {
    if (localStorage.getItem("accessToken")) {
      history.replace("/home");
    }
  }, [history]);

  const doSubmit = async () => {
    if (!email.trim() || loading) return;
    setLoading(true);
    const data = await RequestPasswordReset(email.trim());
    setLoading(false);

    setModalMessage(data.status === "success" ? t('auth.forgotPasswordSuccess') : data.message);
    setiShow(true);
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      doSubmit();
    }
  }

  return (
    <div className="parallax-back">
      <Modal mState={{ iShow, setiShow }}>
        {
          loading ? <p>{t('common.loading')}</p>
          :
          modalMessage
        }
      </Modal>
      <div className="App">
        <div className="App-Auth">
          <header style={{ zIndex: 20 }}>
            <img src={logo} className="App-logo" alt="logo" />
            <p>Cyclone™</p>
          </header>
          <div className="row inputplace">
            <div className="ForgotPasswordBadge"><IoKeyOutline /></div>
            <p className="ForgotPasswordHint">{t('auth.forgotPasswordHint')}</p>
            <div className="inputfield">
              <IoMail />
              <input type="email" inputMode="email" id="ForgotEmailInput" onKeyDown={onKeyDown} placeholder={t('auth.emailPlaceholder')} value={email} autoComplete="email" autoCapitalize="none" autoCorrect="off" spellCheck={false} onChange={(e) => { setEmail(e.target.value); }}></input>
            </div>

            <div className="inputfield ForgotPasswordSubmitRow">
              <button onClick={doSubmit} disabled={loading} className="primaryColor">{loading ? t('auth.processing') : t('auth.sendResetLink')}</button>
            </div>
            <button onClick={() => { history.push('/login'); }} className="AuthLink">{t('auth.back')}</button>
          </div>
        </div>
      </div>
      <div id='stars'></div>
      <div id='stars2'></div>
      <div id='stars3'></div>
    </div>
  );
}
